import { getIn, FieldArray, FastField } from "formik";

FieldArray.WrappedComponent.prototype.shouldComponentUpdate = function(props) {
  if (this.props.disableFast) return true;

  if (this.props.shouldUpdate) {
    return this.props.shouldUpdate(props, this.props);
  }

  const oldVals = getIn(this.props.formik.values, this.props.name);
  const vals = getIn(props.formik.values, this.props.name);

  if (oldVals === undefined && vals !== undefined) return true;
  if (oldVals === vals) return false;
  if (oldVals === null && vals !== null) return true;
  if (oldVals.length !== vals.length) return true;

  if (this.props.deepCompare)
    for (let i = 0, len = vals.length; i < len; i++)
      if (oldVals[i] !== vals[i]) return true;

  if (
    getIn(this.props.formik.errors, this.props.name) !==
      getIn(props.formik.errors, this.props.name) ||
    getIn(this.props.formik.touched, this.props.name) !==
      getIn(props.formik.touched, this.props.name) ||
    Object.keys(this.props).length !== Object.keys(props).length ||
    this.props.formik.isSubmitting !== props.formik.isSubmitting ||
    this.props.formik.isValidating !== props.formik.isValidating
  ) {
    return true;
  }

  return false;
};

FastField.WrappedComponent.prototype.shouldComponentUpdate = function(props) {
  if (this.props.shouldUpdate)
    return this.props.shouldUpdate(props, this.props);

  if (
    getIn(this.props.formik.values, this.props.name) !==
      getIn(props.formik.values, this.props.name) ||
    getIn(this.props.formik.errors, this.props.name) !==
      getIn(props.formik.errors, this.props.name) ||
    getIn(this.props.formik.touched, this.props.name) !==
      getIn(props.formik.touched, this.props.name) ||
    Object.keys(this.props).length !== Object.keys(props).length ||
    this.props.formik.isSubmitting !== props.formik.isSubmitting ||
    this.props.formik.isValidating !== props.formik.isValidating
  )
    return true;

  return false;
};
